import styled from "styled-components";

export const HideMobile = styled.div`
  display: block;
  width: 100%;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ShowMobile = styled.div`
  display: none;
  width: 100%;

  @media (max-width: 768px) {
    display: block;
  }
`;
